export const SLICE_BASE_NAME = 'auth'
export const RndTeam = [
    'dimitriy@spotower.com',
    'ella@spotower.com',
    'talkedem@spotower.com',
    'danielresnikow@spotower.com',
    'shachar@spotower.com',
    'liam@spotower.com',
]